import { selectors } from 'builder/modules/resumeEditor'
import { useConfig } from './useConfig'
import { useTypedSelector } from './useTypedSelector'

export const useResumeReviewFeatureConfig = () => {
  const config = useConfig()
  const autoTailoringFromPublicJobBoard = useTypedSelector(
    selectors.autoTailoringFromPublicJobBoard,
  )

  const isAiResumeReviewFeatureActive =
    !!config?.features?.rbpAiReview && !autoTailoringFromPublicJobBoard.enabled

  return {
    isAiResumeReviewFeatureActive,
  }
}
